import classes from './CloudSut.module.scss'

const CloudSut = () =>
  <span className={classes.CloudSut}>
    DAI Cloud
  </span>

export default CloudSut
